type GetTZAbbreviationInput = {
  date: Date;
  locale: string;
  timezone?: string;
};

export function getTZAbbreviation(input: GetTZAbbreviationInput) {
  return (
    new Intl.DateTimeFormat(input.locale, {
      timeZone: input.timezone,
      timeZoneName: "short",
    })
      .formatToParts(input.date)
      .find((part) => part.type === "timeZoneName")?.value ?? ""
  );
}
